export default __webpack_public_path__ + "static/steve@2x-9c08ab943fb766e32b22059f2761786e.jpg";